import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const initialState = null;

const slice = createSlice({
  name: 'promotions',
  initialState: reHydrateStore('promotions') || initialState,
  reducers: {
    setPromotion: (state, { payload }) => ({ ...payload }),
    setPromotionCode: (state, { payload }) => payload,
    setPromotionError: (state, { payload }) => ({
      ...state,
      error: payload,
    }),
    restore: () => initialState,
  },
});

export const { setPromotion, setPromotionCode, setPromotionError, restore } =
  slice.actions;

export default slice.reducer;
